// extracted by mini-css-extract-plugin
export default {"card":"Details_card__u7lAV","cardImg":"Details_cardImg__uKqTO"};